export default "__VITE_ASSET__DtYGA4nR__"